'use strict'

// Fix error when update CSS :
// Uncaught Error: Cannot find module '../node_modules/parcel-bundler/src/builtins/css-loader.js'
import '../node_modules/parcel-bundler/src/builtins/css-loader'

import Swiper, { Navigation, Pagination, Scrollbar, Parallax, Autoplay } from 'swiper'

import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { SplitText } from "gsap/SplitText"

Swiper.use([Navigation, Pagination, Scrollbar, Parallax, Autoplay])

window.$ = window.jQuery = require('jquery')

const select2 = require('select2')
select2(window.jQuery)
window.Swiper = Swiper
window.gsap = gsap
window.ScrollTrigger = ScrollTrigger
window.SplitText = SplitText

require('../node_modules/jquery-range/jquery.range.js')
require('../node_modules/select2/dist/js/i18n/fr.js')
require('../node_modules/select2/dist/js/i18n/en.js')
require('../node_modules/jquery.nicescroll/dist/jquery.nicescroll.min.js')

global.Plyr = require('../node_modules/plyr/dist/plyr.polyfilled.min.js')
